import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch,useSelector } from "react-redux";
import { fetchDocumentsByThreadId,fetchDocumentsByCase } from "../store/features/documentSlice";
import { fetchShipments,fetchShipmentsByEmail } from "../store/features/shipmentsSlice";
import { getDraftEmail } from "../store/features/emailsSlice";
import DraftBody from "../components/Email/DraftBody";
import DocModHeader from "../components/Header/DocModHeader";
const CCIViewer = () => {
    const { threadId, documentId } = useParams();
    const dispatch = useDispatch();
    const email = "supplychain@linear-works.com";
    const documentsState = useSelector((state) => state.documents);
    const { shipments, status: shipmentStatus } = useSelector((state) => state.shipments);
    const shipment = shipments.find((shipment) => shipment.thread_id === threadId);
    const { thread_id, case_number, documents, emailBodies} = shipment;
    
    // Get the last document
    const lastDocument = documents.reduce((maxDoc, currentDoc) => {
      // Check if mandatory_info or MandatoryInfo is not an empty object
      const hasMandatoryInfo =
        (currentDoc.mandatory_info && Object.keys(currentDoc.mandatory_info).length > 0) ||
        (currentDoc.MandatoryInfo && Object.keys(currentDoc.MandatoryInfo).length > 0);
    
      // Only consider documents with non-empty mandatory_info or MandatoryInfo
      if (hasMandatoryInfo) {
        return currentDoc.id > maxDoc.id ? currentDoc : maxDoc;
      }
      return maxDoc; // Keep the current maxDoc if the condition is not met
    }, documents[0]);

    // Safely access mandatoryInfo with fallbacks
    const mandatoryInfo = lastDocument.content?.MandatoryInfo || lastDocument.content?.mandatory_info || {};
    // Extract the required values with error handling
    const origin = mandatoryInfo?.Origin?.PortOfDespatchArrival?.Value || "N/A"; // Origin (Port of Departure/Arrival)
    const destination = mandatoryInfo?.DeliveryPoint?.CompanyNameAddress?.Value || "N/A"; // Destination (Company Name and Address)
    const destcountry = destination.split(",").pop()?.trim() || "N/A"; // Extract country from destination
    const carrier = mandatoryInfo?.DeliveryPoint?.ContactName?.Value || "N/A"; // Carrier (Ship Name/Flight Number)
    const awb = mandatoryInfo?.Origin?.["Airwaybill Number"]?.Value || "N/A"; // AWB (Airwaybill Number)
    const status = documentsState.status;


    const [isEmailViewerOpen, setIsEmailViewerOpen] = useState(false);
    const {
            data: Emaildata,                // Renamed 'data' to 'Emaildata'
            status: Emailstatus,            // Renamed 'status' to 'Emailstatus'
            mailOpen,                       // Kept original name
            currentMail:currentEmail,       // Kept original name
            pinnedEmails,                   // Kept original name
            } = useSelector((state) => state.emails);
    //Fetch emails
    useEffect(() => {
      dispatch(getDraftEmail({ caseNumber:case_number, email })); // ✅ Fetch draft email when component mounts
    }, [dispatch, case_number, email]);
    const selectedDoc = {"id":99,"name":"Custom Clearance Instruction","link":"/mock_data/Shipment_Registration.pdf"}
    const pdfFile = selectedDoc?.link || "";
    const document_name = selectedDoc?.name || "";
    //Get draft email
    const emailId = 2 //This should be replaced by the api fetching corresponding email id
    
    const handleSendInstruction = () => {
        if (currentEmail) {
            setIsEmailViewerOpen(true);             // Open the modal
        } 
        // Add your logic here (API call, navigation, etc.)
      };

    const EmailViewerModal = ({ isOpen, onClose, email }) => {
        if (!isOpen) return null;
    
        return (
            <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50">
                <div className="bg-white w-[80%] h-[80%] rounded-lg shadow-lg overflow-hidden">
                    <div className="flex justify-between p-4 border-b">
                        <h2 className="text-lg font-bold">Email Draft</h2>
                        <button onClick={onClose} className="rounded-full px-3 py-1 hover:bg-bg-Gray text-lg">&times;</button>
                    </div>
                    <div className="p-4 overflow-auto h-[calc(100%-50px)]">
                        <DraftBody threadId={threadId} initialAttachments={[ { name: document_name, url: pdfFile }]}/>
                    </div>
                </div>
            </div>
        );
    };

    return (
      <div className="flex flex-col h-screen">
      {/* DocModHeader at the top left */}
      <div className="p-4">
        <DocModHeader
          caseId={case_number}
          shipmentId={thread_id}
          origin={origin}
          destination={destination}
          carrier={carrier}
          trackingNumber={awb}
        />
      </div>
    
      {/* Main Content: PDF Viewer and Button */}
      <div className="flex flex-col justify-center items-center flex-grow space-y-4">
        {/* PDF Viewer Container */}
        <div className="w-[100%] h-full shadow-lg border rounded-lg overflow-hidden">
          <iframe
            src={pdfFile}
            title="PDF Viewer"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </div>
    
        {/* Send Instruction Button */}
        <button
          onClick={handleSendInstruction} // Replace with your actual function
          className="px-6 py-2 rounded-full bg-logo text-white hover:bg-logo-darker hover:text-white"
        >
          Send Instruction
        </button>
    
        {/* Email Viewer Modal */}
        <EmailViewerModal
          isOpen={isEmailViewerOpen}
          onClose={() => setIsEmailViewerOpen(false)}
          email={currentEmail}
        />
      </div>
    </div>
    );
  };
  
  export default CCIViewer;